import { createHookWithCallbacksState } from '@move-frontend/auth';
import { useSignUpWithCallbacks } from './useSignUpWithCallbacks';

export const useSignUp = createHookWithCallbacksState(useSignUpWithCallbacks);
